var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5728 8.68863L6.69438 17.5671C6.51149 17.7499 6.27872 17.8414 5.99607 17.8414C5.71343 17.8414 5.48066 17.7499 5.29777 17.5671C5.11488 17.3842 5.02344 17.1514 5.02344 16.8688C5.02344 16.5861 5.11488 16.3533 5.29777 16.1705L14.1762 7.29203H6.59462C6.31197 7.29203 6.07521 7.19626 5.88435 7.00473C5.69348 6.81319 5.59771 6.57643 5.59704 6.29445C5.59638 6.01247 5.69215 5.77571 5.88435 5.58418C6.07655 5.39264 6.3133 5.29688 6.59462 5.29688H16.5704C16.853 5.29688 17.0901 5.39264 17.2816 5.58418C17.4732 5.77571 17.5686 6.01247 17.568 6.29445V16.2702C17.568 16.5529 17.4722 16.7899 17.2807 16.9815C17.0891 17.173 16.8524 17.2685 16.5704 17.2678C16.2884 17.2671 16.0516 17.1714 15.8601 16.9805C15.6686 16.7896 15.5728 16.5529 15.5728 16.2702V8.68863Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpLogo);
export default __webpack_public_path__ + "static/media/up-logo.196d85da02f3684fb729816e5622842f.svg";
export { ForwardRef as ReactComponent };